// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const app = angular.module('landingPage');

app.directive('giBoardsSlider', ($http) => ({
  link(scope, elem, attr) {
    let currentBoard = 0;
    let boards = [];
    let heroes = [];
    $http.get('/landing/boards').success(function (data) {
      ({ boards } = data);
      ({ heroes } = data);
      return (scope.currentBoards = boards.slice(0, 3));
    });

    scope.changeBoards = function (increment) {
      const newIndex = currentBoard + increment;
      if (newIndex >= 0 && newIndex + 3 <= boards.length) {
        currentBoard = newIndex;
        return (scope.currentBoards = boards.slice(
          currentBoard,
          currentBoard + 3
        ));
      }
    };

    scope.boardHero = function (id) {
      for (let hero of heroes.assets) {
        if (hero.id === id) {
          return hero.delivery_urls.thumb612;
        }
      }
    };

    return (scope.boardsCount = () => boards.length);
  },
}));

app.directive('giBackImg', () => ({
  link(scope, element, attr) {
    let url = attr.giBackImg;
    if (url === '') {
      url = scope.boardHero('71299139');
    }

    return element.css({ 'background-image': `url(${url})` });
  },
}));
